import CoinHeartbeat from "@components/utils/CoinHeartbeat/CoinHeartbeat";
import FlyingCoins, { FlyingCoinsRef } from "@components/utils/FlyingCoins/FlyingCoins";
import { BALANCE_BADGE_TOP_ID } from "@constants";
import { forwardRef } from "react";
import { SKINNER_BOX_CONFIG, SKINNER_BOX_STATE } from "../utils";

interface SkinnerBoxCoinsProps {
  state: SKINNER_BOX_STATE;
  isClaimed: boolean;
  zIndex: number;
}

const SkinnerBoxCoins = forwardRef<FlyingCoinsRef, SkinnerBoxCoinsProps>(({ state, isClaimed, zIndex }, ref) => {
  if (state !== SKINNER_BOX_STATE.CLAIMED) {
    return (
      <div
        className="absolute right-[32px] top-[25px] h-4 w-4"
        style={{ zIndex }}
      >
        <CoinHeartbeat
          className="h-full w-full"
          imgClassName="w-full h-full object-contain"
        />
      </div>
    );
  }

  if (isClaimed) {
    return (
      <div
        className="absolute right-[32.07px] top-[25.43px] h-6 w-6"
        style={{ zIndex }}
      >
        <FlyingCoins
          ref={ref}
          className="h-full w-full"
          coinImgSrc="/images/icon-coin.png"
          sourceCoinSize={24}
          targetCoinSize={16}
          count={9}
          targetId={BALANCE_BADGE_TOP_ID}
          randomHorizontalRange={30}
          randomVerticalRange={30}
          randomSizeRange={6}
          delayIn={SKINNER_BOX_CONFIG.FLYING_COINS_DELAY_IN}
          overlay={true}
          duration={SKINNER_BOX_CONFIG.FLYING_COINS_DURATION}
          removeIn={SKINNER_BOX_CONFIG.FLYING_COINS_REMOVE_IN}
        />
      </div>
    );
  }

  return null;
});

SkinnerBoxCoins.displayName = "SkinnerBoxCoins";

export default SkinnerBoxCoins;
